import type { SendTimeOption } from "../types";

export const DEFAULT_SEND_TIME_OPTIONS: SendTimeOption[] = [
  {
    id: "time-last-chat-start",
    label: "When the user started their last chat",
    value: "when-the-user-started-their-last-chat",
    reference: "last-chat-start",
    description: "Schedules relative to the time their last conversation began.",
  },
  {
    id: "time-morning",
    label: "Morning · 9 AM user timezone",
    value: "morning-(9-am-user-timezone)",
    reference: "user-morning",
    description: "Auto-adjusts to 9 AM in the recipient's timezone.",
  },
  {
    id: "time-afternoon",
    label: "Afternoon · 2 PM user timezone",
    value: "afternoon-(2-pm-user-timezone)",
    reference: "user-afternoon",
    description: "Targets early afternoon in the recipient's timezone.",
  },
  {
    id: "time-evening",
    label: "Evening · 7 PM user timezone",
    value: "evening-(7-pm-user-timezone)",
    reference: "user-evening",
    description: "Schedules for early evening in the user's timezone.",
  },
  {
    id: "time-night",
    label: "Night · 10 PM user timezone",
    value: "night-(10-pm-user-timezone)",
    reference: "user-night",
    description: "Great for late-night readers and insomniacs.",
  },
  {
    id: "time-signup",
    label: "At the exact moment they sign up",
    value: "at-the-same-time-they-signup",
    reference: "signup",
    description: "Kick off the email as soon as the user joins.",
  },
];
